import Splitting from 'splitting';
import gsap from 'gsap';
import { ScrollTrigger } from 'gsap/all';
gsap.registerPlugin(ScrollTrigger);

const init = () => {
  Splitting({
    target: "[data-splitting='lines']",
    by: 'lines',
  });

  Splitting({
    target: "[data-splitting='words']",
  });

  Splitting({
    target: "[data-splitting='chars']",
    by: 'chars',
  });

  const els = document.querySelectorAll('[data-splitting], .js-reveal');

  
  els.forEach(el => {
    const start = el.dataset.revealStart || 'top 50%';
    const end = el.dataset.revealEnd || 'bottom top';
    
    gsap.from(el, {
      scrollTrigger: {
        trigger: el,
        start,
        end,
        once: true,
        toggleClass: { targets: el, className: 'is-inview' },
      }
    });
  });
};

const module = () => {
  init();
  document.addEventListener('domUpdated', init);
};

export default module;
